import { LogService } from "../../../shared/services/log.service";
import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";

export class CTRL_417 implements Validator {

    public static id = 'CTRL_417';
    private message = 'error.ctr_417';


    public LOG: LogService = new LogService(CTRL_417);

    
    validate(form: any, map) {

        
        // vérifier si la règle est applicable sur mon formulaire
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_417.id + '_');


        if (rgs.length > 0) {
            for (var rg of rgs) {
                const ctrl = form.controls[rg];
                const envoiInvitationNameWithStepId = map.get(ctrl.value.rgCtrls.first_date);
                const receptionOffresNameWithStepId = map.get(ctrl.value.rgCtrls.second_date);
                const envoiInvitationCtrl = form.controls[envoiInvitationNameWithStepId];
                const receptionOffresCtrl = form.controls[receptionOffresNameWithStepId];
                if (envoiInvitationCtrl.value == "yyyy-MM-dd" && receptionOffresCtrl.value == "yyyy-MM-dd") {
                    // placer le message d'erreur
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message };
                } else {
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false };
                }
            }
        }
    }
}